// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-spinner {
  animation-duration: 0ms !important;
  -webkit-animation-duration: 0ms !important;
  -moz-animation-duration: 0ms !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  height: 50px;
  width: 50px;
  color: #576d7c;
}

.loading-container {
  top: 0;
  background: rgba(0, 0, 0, 0.25);
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 100;
}

.menu-img {
  width: 36px;
  height: 36px;
}

ion-select {
  padding: 11px;
  background: #f9f9fb;
  --background: #f9f9fb;
  border-radius: 8px;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.2);
  transition: all 0.15s;
}

ion-select::part(text) {
  padding-left: 10px;
  font-size: 20px;
  color: #576d7c;
  font-weight: 600;
}

ion-icon {
  pointer-events: none;
}

.ion-button-delete {
  --background: #db0f0f;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.2);
  height: 43px;
  max-width: 20% !important;
  border-radius: 8px !important;
  --border-radius: 8px !important;
  text-transform: none;
  font-size: 20px;
  color: #ffffff;
}

@media screen and (max-width: 355px) {
  .ion-button-delete {
    font-size: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/layouts/main/pages/my-profile/my-profile.component.scss"],"names":[],"mappings":"AAAA;EACE,kCAAA;EACA,0CAAA;EACA,uCAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;AACF;;AAEA;EACE,MAAA;EACA,+BAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,2CAAA;EACA,qBAAA;AACF;;AAEA;EACE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AACA;EACE,qBAAA;EACA,2CAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,+BAAA;EACA,oBAAA;EACA,eAAA;EACA,cAAA;AAEF;;AACA;EACE;IACE,eAAA;EAEF;AACF","sourcesContent":["ion-spinner {\r\n  animation-duration: 0ms !important;\r\n  -webkit-animation-duration: 0ms !important;\r\n  -moz-animation-duration: 0ms !important;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  position: absolute;\r\n  height: 50px;\r\n  width: 50px;\r\n  color: #576d7c;\r\n}\r\n\r\n.loading-container {\r\n  top: 0;\r\n  background: rgba(0, 0, 0, 0.25);\r\n  position: fixed;\r\n  width: 100vw;\r\n  height: 100vh;\r\n  z-index: 100;\r\n}\r\n\r\n.menu-img {\r\n  width: 36px;\r\n  height: 36px;\r\n}\r\n\r\nion-select {\r\n  padding: 11px;\r\n  background: #f9f9fb;\r\n  --background: #f9f9fb;\r\n  border-radius: 8px;\r\n  box-shadow: 0px 0px 15px #00000033;\r\n  transition: all 0.15s;\r\n}\r\n\r\nion-select::part(text) {\r\n  padding-left: 10px;\r\n  font-size: 20px;\r\n  color: #576d7c;\r\n  font-weight: 600;\r\n}\r\n\r\nion-icon {\r\n  pointer-events: none;\r\n}\r\n.ion-button-delete {\r\n  --background: #db0f0f;\r\n  box-shadow: 0px 0px 15px #00000033;\r\n  height: 43px;\r\n  max-width: 20% !important;\r\n  border-radius: 8px !important;\r\n  --border-radius: 8px !important;\r\n  text-transform: none;\r\n  font-size: 20px;\r\n  color: #ffffff;\r\n}\r\n\r\n@media screen and (max-width: 355px) {\r\n  .ion-button-delete {\r\n    font-size: 18px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
